import React, { useEffect, useState } from "react";
import { hotelApi } from "./hotelApi";

export default function MpesaReport({ onBack }) {
  const today = new Date().toISOString().slice(0, 10);

  const [from, setFrom] = useState(today);
  const [to, setTo] = useState(today);
  const [rows, setRows] = useState([]);
  const [summary, setSummary] = useState(null);
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState("");

  const loadReport = async () => {
    try {
      setLoading(true);
      setMsg("");

      const res = await hotelApi.get("/reports/mpesa", {
        params: { from, to },
      });

      const data = Array.isArray(res.data?.rows) ? res.data.rows[0] : null;

      setSummary(data?.summary || null);
      setRows(Array.isArray(data?.rows) ? data.rows : []);
    } catch (e) {
      console.error(e);
      setMsg(
        "Failed to load M-Pesa report: " +
          (e?.response?.data?.error || e?.message || "Unknown error")
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadReport();
  }, []);

  return (
    <div style={styles.wrap}>
      <div style={styles.header}>
        <h2 style={{ margin: 0 }}>💳 M-Pesa Report</h2>

        <div style={styles.actions}>
          <input
            style={styles.input}
            type="date"
            value={from}
            onChange={(e) => setFrom(e.target.value)}
          />

          <input
            style={styles.input}
            type="date"
            value={to}
            onChange={(e) => setTo(e.target.value)}
          />

          <button style={styles.btn} onClick={loadReport} disabled={loading}>
            {loading ? "Loading..." : "Load"}
          </button>

          <button style={styles.btn2} onClick={onBack}>
            Back
          </button>
        </div>
      </div>

      {msg && <div style={styles.error}>{msg}</div>}

      <div style={styles.cards}>
        <div style={styles.card}>
          <div style={styles.label}>Transactions</div>
          <div style={styles.value}>
            {Number(summary?.total_transactions || rows.length || 0)}
          </div>
        </div>

        <div style={styles.card}>
          <div style={styles.label}>Total Amount</div>
          <div style={styles.value}>
            {Number(summary?.total_amount || 0).toFixed(2)}
          </div>
        </div>
      </div>

      <div style={styles.tableBox}>
        <table style={styles.table}>
          <thead>
            <tr>
              <th style={styles.th}>ID</th>
              <th style={styles.th}>Account No</th>
              <th style={styles.th}>M-Pesa Code</th>
              <th style={styles.th}>Amount</th>
              <th style={styles.th}>Cust No</th>
              <th style={styles.th}>First Name</th>
              <th style={styles.th}>Middle Name</th>
              <th style={styles.th}>Last Name</th>
              <th style={styles.th}>Trans Date</th>
              <th style={styles.th}>Counted</th>
              <th style={styles.th}>TDate</th>
            </tr>
          </thead>

          <tbody>
            {rows.length === 0 ? (
              <tr>
                <td style={styles.td} colSpan={11}>
                  No M-Pesa records found.
                </td>
              </tr>
            ) : (
              rows.map((r) => (
                <tr key={r.id}>
                  <td style={styles.td}>{r.id}</td>
                  <td style={styles.td}>{r.account_no}</td>
                  <td style={styles.td}>{r.mpesa_code}</td>
                  <td style={styles.td}>{Number(r.amount || 0).toFixed(2)}</td>
                  <td style={styles.td}>{r.custno}</td>
                  <td style={styles.td}>{r.fname}</td>
                  <td style={styles.td}>{r.mname}</td>
                  <td style={styles.td}>{r.lname}</td>
                  <td style={styles.td}>{r.transdate}</td>
                  <td style={styles.td}>{Number(r.counted || 0) === 1 ? "Yes" : "No"}</td>
                  <td style={styles.td}>{r.tdate}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

const styles = {
  wrap: { padding: 10 },
  header: {
    display: "flex",
    justifyContent: "space-between",
    gap: 12,
    alignItems: "center",
    marginBottom: 12,
    flexWrap: "wrap",
  },
  actions: {
    display: "flex",
    gap: 8,
    flexWrap: "wrap",
  },
  input: {
    padding: 10,
    borderRadius: 10,
    border: "1px solid #d1d5db",
  },
  btn: {
    padding: "10px 14px",
    borderRadius: 10,
    border: "none",
    background: "#0f766e",
    color: "#fff",
    fontWeight: 800,
    cursor: "pointer",
  },
  btn2: {
    padding: "10px 14px",
    borderRadius: 10,
    border: "1px solid #d1d5db",
    background: "#fff",
    fontWeight: 800,
    cursor: "pointer",
  },
  error: {
    background: "#fee2e2",
    color: "#991b1b",
    padding: 10,
    borderRadius: 10,
    marginBottom: 10,
    fontWeight: 700,
  },
  cards: {
    display: "grid",
    gridTemplateColumns: "repeat(2, minmax(180px, 1fr))",
    gap: 12,
    marginBottom: 12,
  },
  card: {
    background: "#fff",
    border: "1px solid #e5e7eb",
    borderRadius: 14,
    padding: 14,
  },
  label: {
    color: "#64748b",
    fontWeight: 800,
    fontSize: 13,
  },
  value: {
    marginTop: 8,
    fontSize: 24,
    fontWeight: 900,
  },
  tableBox: {
    overflowX: "auto",
    background: "#fff",
    border: "1px solid #e5e7eb",
    borderRadius: 14,
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
  },
  th: {
    textAlign: "left",
    padding: 10,
    borderBottom: "1px solid #e5e7eb",
    background: "#f8fafc",
    whiteSpace: "nowrap",
  },
  td: {
    padding: 10,
    borderBottom: "1px solid #f1f5f9",
    whiteSpace: "nowrap",
  },
};